// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB3uP5DIB4n_P5ZWxiRy6rBjuf-cwNWIx8",
    authDomain: "splitpay-fab9b.firebaseapp.com",
    databaseURL: "https://splitpay-fab9b-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "splitpay-fab9b",
    storageBucket: "splitpay-fab9b.appspot.com",
    messagingSenderId: "742070753239",
    appId: "1:742070753239:web:44a5f4f8238bd8ca461d92",
    measurementId: "G-87QQ3QXXVC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getDatabase(app);